module.exports = __webpack_public_path__ + "img/Transaction history - Icon.81314a34.svg";